import { call } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';

export default function* wsDisconnection(action) {
  try {
    if (window.wsConnection) {
      window.wsConnection.close();
      window.wsConnection = null;
    }
  } catch (e) {
    yield call(rejectActionPromise(action, e));
  }
}
